export const isDateExpired = (dateTime) => {
    const now = new Date()
    const date = new Date(dateTime)
    return date < now
}